import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/organisation/categories")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/platform/categories" });
  },
});
